import { defineMessage, MessageDescriptor } from 'react-intl';

export const UNSUPPORTED_PROP_VALIDATION_MESSAGE: Record<
  string,
  MessageDescriptor
> = {
  relativeValRepMisalignedDatapoints: defineMessage({
    id: 'nKKQZgf/HDK4kuqw',
    defaultMessage:
      'Relative value representation not supported with misaligned datapoints. Falling back to absolute value representation',
    description:
      'Message emitted from the charts when relative value representation is not supported due to misaligned datapoints present in the dataset',
  }),
  tooManyUnitsInSeries: defineMessage({
    id: 'wJwh0+z/EA10jBl5',
    defaultMessage: 'Your dataset has returned more than two units.',
    description:
      'Message emitted from the charts when more than two units are present in the dataset',
  }),
  stackedSeriesMoreThanOneUnits: defineMessage({
    id: 'vcDuuUYjmbp403Zc',
    defaultMessage: 'More than one units is not supported on stacked charts.',
    description:
      'Message emitted from the charts when more than one units is present in stacked charts',
  }),
};
